import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import styled from 'styled-components';
import {
  Wrapper,
  TextWrapper,
  Title,
  Description,
  Count,
} from 'legacyComponents/layout/menuOption';
import { Icon } from 'components';

export const CollectionListItem = withNamespaces()(
  observer(({ collection, t }) => {
    const {
      id,
      name,
      projectsCount,
      description,
      projectIsInCollection,
      AddProject,
      RemoveProject,
    } = collection;
    return (
      <div
        key={id}
        onClick={
          projectIsInCollection ? () => RemoveProject() : () => AddProject()
        }
      >
        <ItemWrapper projectIsInCollection={projectIsInCollection}>
          <Icon name='collection' title={name} />
          <ItemTextWrapper>
            <Title>
              {name}&nbsp;<Count>({projectsCount})&nbsp;</Count>
              <span>
                {'- '}
                {projectIsInCollection ? t('Remove') : t('Add')}
              </span>
            </Title>
            <Description>{description}</Description>
          </ItemTextWrapper>
        </ItemWrapper>
      </div>
    );
  }),
);

const ItemWrapper = styled(Wrapper)`
  position: relative;
  > div:nth-of-type(1) {
    background-color: ${props =>
      props.projectIsInCollection
        ? props.theme.color.primary
        : 'rgba(0,0,0,0.25)'};
  }
  > div:nth-of-type(2) {
    > h2 {
      > span:nth-of-type(2) {
        color: ${props => props.theme.color.wfWhite};
        transition: color 100ms ease-in-out;
      }
    }
  }
  &:hover {
    > div:nth-of-type(1) {
      background-color: ${props =>
        props.projectIsInCollection
          ? props.theme.color.wfOrange
          : props.theme.color.primary};
      left: 15px;
    }
    > div:nth-of-type(2) {
      > h2 {
        > span:nth-of-type(2) {
          color: ${props => props.theme.color.wfGrey500};
        }
      }
    }
  }
`;

const ItemTextWrapper = styled(TextWrapper)`
  width: 430px;
`;
